module.exports = __webpack_public_path__ + "static/media/78_dzz2.c39bf2d3.jpg";